import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faWhatsapp,
  faFacebookMessenger,
} from "@fortawesome/free-brands-svg-icons";

const homepage = (props) => {
  return (
    <>
      <div className="homepageText">
        <h2>LOCKHART</h2>
        <h2 className="red88">88</h2>

        <br />

        <h4 className="right-rotate">SPORT · GAME</h4>
      </div>
      {/* <div className="mainIcons d-flex flex-column">
        <a href="https://wa.me/23667588" target="_blank">
          <FontAwesomeIcon icon={faWhatsapp} />
        </a>
        <a href="http://m.me/zincgrouphk" target="_blank">
          <FontAwesomeIcon icon={faFacebookMessenger} />
        </a>
      </div> */}
      <div className="mainIcons">
        <a target="_blank" href={process.env.REACT_APP_WHATSAPP_URL + props.store.whatsapp}>
          <FontAwesomeIcon icon={faWhatsapp} />
        </a>
        <p>
          whatsapp
        </p>
        <a target='_blank' href={props.store.facebook_messenger} target="_blank">
          <FontAwesomeIcon icon={faFacebookMessenger} />
        </a>
        <p>
          facebook
        </p>
      </div>
    </>
  );
};

export default homepage;
